import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'sm:bg-bg-items-white mb-8 py-0 sm:mb-24 sm:py-10'
  }
});
